goog.provide('el8.appchart.letters.rawFaxNag');

goog.require('el8.service.urls');
goog.require('el8.template.appchart.letters');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Dipdown');
goog.require('el8.uiwidget.Form');
goog.require('el8.util.consts');
goog.require('el8.util.string');


/**
 * This shows a dipdown under the To field when a user
 * enters a raw fax number, to encourage them to create
 * a contact instead.
 */
el8.appchart.letters.rawFaxNag = (function() {

    var container = $('#third-pane-container');

    var rawFaxDipdown = null;
    var dipdownForm = null;

    var faxNum = null;
    var callbackFn = null;

    return {

        // call this when the user has entered a new raw fax num
        show: function(spec) {
            if (!rawFaxDipdown) { init(spec); }
            faxNum = spec.faxNum;
            callbackFn = spec.callbackFn;
            rawFaxDipdown.show();
            dipdownForm.render();
            $(document).trigger('raw-fax-show');
        },

        // call this whenever hiding the letter pane
        destroy: function() {
            this.hideIfShowing();
            rawFaxDipdown = null;
            dipdownForm = null;
            faxNum = null;
            callbackFn = null;
        },

        hideIfShowing: function() {
            if (rawFaxDipdown && rawFaxDipdown.isShowing()) {
                rawFaxDipdown.hide();
            }
        }

    };


    // every time a new letter pane is shown, we need to recreate the rawFaxDipdown and form
    function init(spec) {
        var offsetTop = 40;
        rawFaxDipdown = new el8.uiwidget.Dipdown({
            containerClass: 'el8InfoTipDark',
            tailClass: 'el8DipdownTailDark',
            anchor: spec.anchor,
            appendElt: spec.appendElt,
            isModal: false,
            width: 410,
            height: 180,
            offsets: { top: offsetTop },
            contentFn: function() {
                return el8.template.appchart.letters.rawFaxNagDipdown({ ftue: el8.appchart.letters.faxGuide.isInProgress() });
            },
            renderFn: function() {
                var $dipdownContent = rawFaxDipdown.getContentElt();
                dipdownForm = new el8.uiwidget.Form({
                    fields: [
                        {
                            //radio
                            name: 'contactType',
                            selector: ':input[name="contactType"]'
                        },
                        {
                            name: 'firstName',
                            selector: ':input[name="firstName"]',
                            maxLength: 50,
                            infoText: 'First Name'
                        },
                        {
                            name: 'lastName',
                            selector: ':input[name="lastName"]',
                            maxLength: 60,
                            infoText: 'Last Name'
                        },
                        {
                            name : 'name',
                            selector: ':input[name="name"]',
                            maxLength: 100,
                            infoText: 'Organization Name'
                        }
                    ],
                    container: $('.dipdown-form', $dipdownContent),
                    buttonElt: $('.button-section', $dipdownContent),
                    firstFocusSelector: ':input[name="firstName"]'
                });
                dipdownForm.addSaveButton(saveFn, true);
                if (el8.appchart.letters.faxGuide.isInProgress()) {
                    dipdownForm.addButton('close', 'No, thanks', function() { rawFaxDipdown.hide(); });
                }

                $dipdownContent.on('change', ':input[name="contactType"]',  function() {
                    if (dipdownForm.getVal('contactType') === el8.util.consts.PHYSICIAN_TYPE) {
                        $('.medical-group-block', $dipdownContent).hide();
                        $('.physician-block', $dipdownContent).show();
                    } else {
                        $('.medical-group-block', $dipdownContent).show();
                        $('.physician-block', $dipdownContent).hide();
                    }
                });
            }
        });

        var super_hide = rawFaxDipdown.hide;
        rawFaxDipdown.hide = function() {
            super_hide.call(rawFaxDipdown);
            $(document).trigger('raw-fax-hide');
        };
    }

    // create a new contact from the information entered
    function saveFn() {
        dipdownForm.disable();

        var newContact = el8.data.physicians.create({
            contactType: dipdownForm.getVal('contactType'),
            fax: el8.util.string.cleanPhoneNum(faxNum)
        });
        var postDict;

        if (dipdownForm.getVal('contactType') === el8.util.consts.PHYSICIAN_TYPE) {
            if (!dipdownForm.getVal('firstName') || !dipdownForm.getVal('lastName')) {
                el8.uiwidget.alert('Please enter a first and last name.');
                dipdownForm.enable();
                return false;
            }
            newContact.setFirstName(dipdownForm.getVal('firstName'));
            newContact.setLastName(dipdownForm.getVal('lastName'));
            // using physician.asMap because this view expects a bunch of fields
            // that we don't have in this form
            postDict = newContact.asMap(true);

        } else {
            if (!dipdownForm.getVal('name')) {
                el8.uiwidget.alert('Please enter a name.');
                dipdownForm.enable();
                return false;
            }
            postDict = newContact.asMap(true);
            postDict['name'] = dipdownForm.getVal('name');
        }

        el8.appservice.notifier.notify('Saving new connection...');
        $.el8_ajax({
            url: el8.service.urls.get('connections'),
            type: 'POST',
            data: JSON.stringify(postDict),
            success: function(data) {
                el8.appservice.notifier.notify('Fax number saved');
                var contact = el8.data.physicians.create(data);
                if (callbackFn) { callbackFn(contact); }
                rawFaxDipdown.hide();
            },
            error: function() { dipdownForm.enable(); }
        });
    }

})();